import LanguageDTO from '../languageDTO';

export class Process_TranslationDTO {
  processId: number;

  languageId: number;

  name: string;

  description?: string;

  lang?: LanguageDTO;

  constructor() {
    this.processId = -1;
    this.languageId = -1;
    this.name = '';
  }
}
